/*
 * Javascript for the all pages
*/
import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

import select2 from "select2";

import "parsleyjs";


import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";

import "lazysizes";

import Waves from "../vendor/waves";
import { trackOutboundLink } from "./analytics";

import featherlightFactory from 'featherlight';
import featherlightGalleryFactory from 'featherlight/release/featherlight.gallery.min.js';

featherlightFactory(window, jQuery);
featherlightGalleryFactory(window, jQuery);

window.featherlight = jQuery.featherlight;



var external_url;

window.addEventListener("load", function(){
	const wavesInstance = Waves || (typeof window !== "undefined" ? window.Waves : null);
	if (wavesInstance) {
		console.log("Waves loaded");
		wavesInstance.init();
		wavesInstance.attach(".button, .ripple");
	} else {
		console.log("Waves not loaded");
	}

	// Remove no-js class from html
	document.documentElement.classList.remove("no-js");

	var cookieconsent_status = getCookie('cookieconsent_status');
	if (cookieconsent_status !== 'dismiss') {
		// Let consent-gated features (e.g. reader-count.js) react without polling.
		var notifyConsentChange = function () {
			var analytics = false;
			try { analytics = CookieConsent.acceptedCategory('analytics'); } catch (e) {}
			window.dispatchEvent(new CustomEvent('eauk:consentchange', { detail: { analytics: analytics } }));
		};
		CookieConsent.run({
			onConsent: ({ cookie }) => {
				window.consent_status = true;
				notifyConsentChange();
			},
			onChange: ({ cookie, changedCategories }) => {
				notifyConsentChange();
			},
			guiOptions: {
				consentModal: {
					layout: "box",
					position: "bottom left",
					equalWeightButtons: false,
					flipButtons: false
				},
				preferencesModal: {
					layout: "bar",
					position: "left",
					equalWeightButtons: false,
					flipButtons: false
				}
			},
			categories: {
				necessary: {
					readOnly: true
				},
				analytics: {
					enabled: true
				}
			},
			language: {
				default: "en",
				autoDetect: "browser",
				translations: {
					en: {
						consentModal: {
							title: "Cookies on our website",
							description: "We use some essential cookies to ensure you get the best experience while on our website.",
							acceptAllBtn: "Accept all",
							acceptNecessaryBtn: "Reject all",
							showPreferencesBtn: "Manage preferences",
							footer: "<a href=\"/privacy-policy\">Privacy Policy</a>\n<a href=\"/cookie-policy\">Cookie policy</a>"
						},
						preferencesModal: {
							title: "Consent Preferences Center",
							acceptAllBtn: "Accept all",
							acceptNecessaryBtn: "Reject all",
							savePreferencesBtn: "Save preferences",
							closeIconLabel: "Close modal",
							serviceCounterLabel: "Service|Services",
							sections: [
								{
									title: "Cookie Usage",
									description: "We use cookies to enhance your experience of using our website. Some essential features on our website won’t work without cookies.."
								},
								{
									title: "Strictly Necessary Cookies <span class=\"pm__badge\">Always Enabled</span>",
									description: "These cookies are required in order for the website to work as intended.",
									linkedCategory: "necessary"
								},
								{
									title: "Analytics Cookies",
									description: "These cookies help us enhance the website so we can anonymously analyse how people engage with our website..",
									linkedCategory: "analytics"
								},
								{
									title: "More information",
									description: "For any query in relation to our policy on cookies and your choices, please <a class=\"cc__link\" href=\"/contact-us\">contact us</a>."
								}
							]
						}
					}
				}
			}
		});
		/*
		window.cookieconsent.initialise({
			"palette": {
				"popup": {
					"background": "#292d58",
					"text": "#ffffff"
				},
				"button": {
					"background": "#0ba0b3",
					"text": "#ffffff"
				}
			},
			"content": {
				"dismiss": "Got it!",
				"link": "Read our privacy policy",
				"href": "https://www.eauk.org/privacy-policy"
			},
			onInitialise: function() {
				window.consent_status = this.hasConsented();
			},
			onStatusChange: function() {
				window.consent_status = this.hasConsented();
			}
		});*/
	} else {
		window.consent_status = true;
	}
});

export function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	var expires = "expires="+ d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
export function getCookie(cname) {
	var name = cname + "=";
	var ca = document.cookie.split(';');
	for(var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}
window.setCookie = setCookie;
window.getCookie = getCookie;
window.getUrlParameter = getUrlParameter;

function initUserContextBridge() {
	if (typeof window === 'undefined' || typeof document === 'undefined') {
		return;
	}
	if (window.__eaukUserContextBridgeInit) {
		return;
	}
	window.__eaukUserContextBridgeInit = true;

	window.dataLayer = window.dataLayer || [];
	if (typeof window.csrfTokenName === 'undefined') {
		window.csrfTokenName = null;
	}
	if (typeof window.csrfTokenValue === 'undefined') {
		window.csrfTokenValue = null;
	}
	window.eaukUserData = window.eaukUserData || {
		isLoggedIn: false,
		isMember: false,
		isLapsed: false,
		isGuest: true,
		membershipId: null,
		isStaff: false
	};

	let lastPushedUserId = null;
	let lastPushedIsStaff = null;

	function ensureLoad(fn) {
		if (document.readyState === 'complete') {
			fn();
		} else {
			window.addEventListener('load', fn, { once: true });
		}
	}

	function handleLoginRedirect(detail) {
		if (!detail) {
			return;
		}

		if (detail.loginRedirectUrl) {
			ensureLoad(function () {
				if (typeof window.setCookie === 'function') {
					//window.setCookie('login_redirect', detail.loginRedirectUrl, detail.loginRedirectExpiry ?? (1/24));
				}
			});
		} else if (detail.clearLoginRedirect) {
			ensureLoad(function () {
				if (typeof window.setCookie === 'function') {
					window.setCookie('login_redirect', '', -1);
				}
			});
		}
	}

	function applyUserData(detail) {
		if (!detail) {
			return;
		}

		window.eaukUserData = Object.assign({}, window.eaukUserData, detail);

		ensureLoad(function () {
			if (!document.body) {
				return;
			}

			if (window.eaukUserData.isLoggedIn) {
				document.body.classList.add('logged-in');
			} else {
				document.body.classList.remove('logged-in');
			}
		});

		if (window.eaukUserData.membershipId) {
			const payload = { userId: window.eaukUserData.membershipId };
			if (window.eaukUserData.isStaff) {
				payload.event = 'traffic_type';
				payload.traffic_type = 'internal';
			}
			if (window.eaukUserData.membershipId !== lastPushedUserId || window.eaukUserData.isStaff !== lastPushedIsStaff) {
				window.dataLayer.push(payload);
				lastPushedUserId = window.eaukUserData.membershipId;
				lastPushedIsStaff = window.eaukUserData.isStaff;
			}
		}

		handleLoginRedirect(window.eaukUserData);
	}

	function readUserContext(node) {
		if (!node || typeof node.getAttribute !== 'function') {
			return null;
		}
		const raw = node.getAttribute('data-eauk-user-context');
		if (!raw) {
			return null;
		}
		try {
			return JSON.parse(raw);
		} catch (error) {
			console.warn('Unable to parse user context payload.', error);
			return null;
		}
	}

	function scanForContext(root) {
		const target = (root || document).querySelector ? (root || document).querySelector('[data-eauk-user-context]') : null;
		if (!target) {
			return;
		}
		const context = readUserContext(target);
		if (context) {
			applyUserData(context);
		}
	}

	if (typeof MutationObserver !== 'undefined') {
		const observer = new MutationObserver(function (mutations) {
			let found = false;
			for (const mutation of mutations) {
				if (found) break;
				for (const node of mutation.addedNodes) {
					if (typeof Node !== 'undefined' && node.nodeType !== Node.ELEMENT_NODE) {
						continue;
					}
					if (node && typeof node.getAttribute === 'function' && node.hasAttribute('data-eauk-user-context')) {
						const context = readUserContext(node);
						if (context) {
							applyUserData(context);
							found = true;
							break;
						}
					} else if (node && typeof node.querySelector === 'function') {
						const inner = node.querySelector('[data-eauk-user-context]');
						if (inner) {
							const context = readUserContext(inner);
							if (context) {
								applyUserData(context);
								found = true;
								break;
							}
						}
					}
				}
			}
			// The data-eauk-user-context element is injected once by Sprig on page load.
			// Disconnect as soon as it is found so the observer stops firing on every
			// subsequent DOM mutation (lazysizes, reveal, Swiper, etc.).
			if (found) {
				observer.disconnect();
			}
		});
		// Observe document.body rather than documentElement — content is never injected
		// directly into <html>, so there is no value in watching it.
		observer.observe(document.body, { childList: true, subtree: true });
	}

	scanForContext(document);

	window.addEventListener('eauk:user-data', function (event) {
		applyUserData(event.detail || {});
	});
}

initUserContextBridge();

async function refreshCsrfContext({ force = false } = {}) {
	const hasExistingTokens = Boolean(window.csrfTokenName && window.csrfTokenValue);
	if (hasExistingTokens && !force) {
		return;
	}

	const requestOptions = {
		credentials: 'same-origin',
		headers: {
			'X-Requested-With': 'XMLHttpRequest',
		},
	};

	try {
		const [paramResponse, tokenResponse] = await Promise.all([
			fetch('/actions/blitz/csrf/param', requestOptions),
			fetch('/actions/blitz/csrf/token', requestOptions),
		]);

		if (!paramResponse.ok || !tokenResponse.ok) {
			throw new Error('Unexpected response when refreshing CSRF context.');
		}

		const [paramText, tokenText] = await Promise.all([
			paramResponse.text(),
			tokenResponse.text(),
		]);

		const csrfParam = paramText.trim();
		const csrfToken = tokenText.trim();

		if (csrfParam) {
			window.csrfTokenName = csrfParam;
		}
		if (csrfToken) {
			window.csrfTokenValue = csrfToken;
		}

		window.dispatchEvent(new CustomEvent('eauk:user-data', {
			detail: {
				csrfTokenName: window.csrfTokenName,
				csrfTokenValue: window.csrfTokenValue,
			},
		}));
	} catch (error) {
		console.warn('Unable to refresh CSRF context.', error);
	}
}

window.refreshCsrfContext = refreshCsrfContext;

// Only pre-fetch a CSRF token when the page actually contains a form that needs
// one. The site search box is a GET form (no token required) and most pages have
// no POST form at all, so the unconditional call was firing two CSRF requests
// (/actions/blitz/csrf/param + /token) on every cached page view for nothing.
// Pages that inject a POST form later can dispatch `eauk:refresh-csrf`, and
// form-join-us.js self-fetches the token if it is still missing at submit time.
if (document.querySelector('form[method="post" i], form[data-needs-csrf]')) {
	refreshCsrfContext();
}

window.addEventListener('eauk:refresh-csrf', () => {
	refreshCsrfContext({ force: true });
});

export function showLoadingBar() {
	$('body').append('<div class="animated-loading-bar fixed"></div>');
}
export function removeLoadingBar() {
	$('.animated-loading-bar.fixed').remove();
}

export function isEmail(email) {
	var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
	return regex.test(email);
}
export function isValidPostcode(postcode) {
	var postcodeRegEx = /[A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2}/i;
	return postcodeRegEx.test(postcode);
}


export function getUrlParameter(sParam) {
	var sPageURL = decodeURIComponent(window.location.search.substring(1)),
			sURLVariables = sPageURL.split('&'),
			sParameterName,
			i;

	for (i = 0; i < sURLVariables.length; i++) {
		sParameterName = sURLVariables[i].split('=');

		if (sParameterName[0] === sParam) {
			return sParameterName[1] === undefined ? true : sParameterName[1];
		}
	}
};

export function sendEvent(event, event_category, event_action, event_label, event_value, nonInteraction) {
	//console.log('sendEvent');

	//If window.dataLayer exists
	if (typeof window.dataLayer !== "undefined") {
		window.dataLayer.push({
			event: event,
			event_category: event_category,
			event_action: event_action,
			event_label: event_label,
			event_value: parseInt(event_value, 10),
			nonInteraction: nonInteraction,
		});

		/*console.log('window.dataLayer exists');
		console.log('event: ' + event);
		console.log('event_category: ' + event_category);
		console.log('event_action: ' + event_action);
		console.log('event_label: ' + event_label);
		console.log('event_value: ' + event_value);
		console.log('nonInteraction: ' + nonInteraction);*/
	} else {
		console.log("window.dataLayer is undefined");
	}
}

// Open external links in a popup modal notice
(function($) {
	$(window).on('load', function(){
		$.expr[":"].external = function(a) {
			var linkhn = a.hostname.split('.').reverse();
			var linkHref = linkhn[1] + "." + linkhn[0];

			var domainhn = window.location.hostname.split('.').reverse();
			var domainHref = domainhn[1] + "." + domainhn[0];

			return !a.href.match(/^mailto\:/) && !a.href.match(/^tel\:/) && linkHref !== domainHref;
		};

		$("a:external").addClass("ext_link");
		$('.ext_link').each(function() {
			var ext = $(this);
			if(ext.attr('data-featherlight')) {
				ext.removeClass('ext_link');
			}
			if(ext.hasClass('sponsored')) {
				ext.removeClass('ext_link');
			}
			if (this.href.indexOf('mailto:') != -1) {
				ext.removeClass('ext_link');
			}
			if (this.href.indexOf('tel:') != -1) {
				ext.removeClass('ext_link');
			}
		});

		$(function() {
			$('a.ext_link').click(function() {
				external_url = $(this).attr('href');
				trackOutboundLink(external_url); //If we want the pop-up back, remove this line
			});
					/*
				console.log(external_url.indexOf('eauk.org'));
				if(external_url.indexOf('eauk.org') == -1) {
					$.featherlight($('#external-link-notice'), {});
					$('#external-link-notice span').html('<a href="'+external_url+'" onclick="trackOutboundLink('+external_url+'); return false;" target="_blank">'+external_url+'</a>');
					$('.featherlight-close-icon').addClass('hidden');
					return false;
				}
			});
			$('#external-link-notice .continue').click(function() {
				trackOutboundLink(external_url);
				window.open(external_url);
				$.featherlight.close();
				$('.featherlight-close-icon').removeClass('hidden');
			});
			$(document).on('click','#external-link-notice .cancel, #external-link-notice a', function() {
				$.featherlight.close();
				$('.featherlight-close-icon').removeClass('hidden');
			});*/
		});
	});

	$('input[type=radio][name=feedback-star]').change(function() {
		type = $(this).data('type');
		rating = $(this).data('rating');
		if(type && rating) {
			if(!$('body').hasClass('devmode-true')) {
				//sendEvent(event, event_category, event_action, event_label, event_value, nonInteraction)
				sendEvent('event', type, 'feedback', rating, undefined, false);
			}
			$('.stars').addClass('hidden');
			$('.thanks').removeClass('hidden');
			setCookie(type+'-feedback', true, 9999);
			//$.featherlight.close();
		}
	});
})(jQuery);

//if (Modernizr.touchevents) {} // Keep this here!!!
